import { render } from "./Toast.vue?vue&type=template&id=6d8e50d0"
import script from "./Toast.vue?vue&type=script&lang=js"
export * from "./Toast.vue?vue&type=script&lang=js"
script.render = render

export default script